import { message } from "antd";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useAppContext } from "../../components/contexts/appContext";
import Spinner from "../../components/spinner";

const GoogleOAuthRedirect = () => {
	const [searchParams] = useSearchParams();
	const { loadCurrentUser } = useAppContext();
	const navigate = useNavigate();
	const code = searchParams.get("code");

	useEffect(() => {
		if (code) {
			axios.post("google/login", { code }).then((resp) => {
				if (resp.data?.data?.token) {
					localStorage.setItem("user-access-token", resp.data.data.token);
					loadCurrentUser();
					message.success({
						content: "Login successful",
						key: "login",
						duration: 2,
					});
				}
			});
		} else {
			navigate("/login");
		}
	}, [code]);

	return <Spinner />;
};

export default GoogleOAuthRedirect;
